import { CreateBusinessPayload, UpdateBusinessPayload } from "../../../interfaces/BusinessObject";

export function buildCreateBusinessPayload(payload: CreateBusinessPayload): Record<string, unknown> {
  const body: Record<string, unknown> = {
    name: payload.name,
    listingType: payload.listingType,
    phone: payload.phone,
    description: payload.description ?? null,
    collaborators: payload.collaborators ?? [],
  };
  // Only include ownerId if the caller explicitly provided it (null = orphan).
  if (payload.ownerId !== undefined) body.ownerId = payload.ownerId;
  // Map-pin coordinates — sent together; null clears, undefined omits.
  if (payload.latitude !== undefined) body.latitude = payload.latitude;
  if (payload.longitude !== undefined) body.longitude = payload.longitude;
  return body;
}

export function buildUpdateBusinessPayload(payload: UpdateBusinessPayload): Record<string, unknown> {
  const body: Record<string, unknown> = {};
  if (payload.name !== undefined) body.name = payload.name;
  if (payload.listingType !== undefined) body.listingType = payload.listingType;
  if (payload.phone !== undefined) body.phone = payload.phone;
  if (payload.description !== undefined) body.description = payload.description;
  if (payload.collaborators !== undefined) body.collaborators = payload.collaborators;
  // Tri-state: undefined → leave alone, null → orphan, string → assign.
  if (payload.ownerId !== undefined) body.ownerId = payload.ownerId;
  // Tri-state coords: undefined → leave alone, null → clear, number → set.
  if (payload.latitude !== undefined) body.latitude = payload.latitude;
  if (payload.longitude !== undefined) body.longitude = payload.longitude;
  // Tri-state banner: undefined → leave alone, null → clear, string → set.
  if (payload.bannerUrl !== undefined) body.bannerUrl = payload.bannerUrl;
  // Tri-state logo: undefined → leave alone, null → clear, string → set.
  if (payload.logoUrl !== undefined) body.logoUrl = payload.logoUrl;
  return body;
}
